import { useEffect } from 'react';
import { Provider } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/provider.pb';
import { AnimatePresence } from 'motion/react';
import { useTranslation } from '@frontend/i18n';
import { SCHEDULE_AVAILABILITY_HOURS_MAX_WIDTH } from '@frontend/schedule-availability-hours';
import { Modal, ModalControlModalProps } from '@frontend/design-system';
import { useAddProviderV3Context } from '../../context/AddProviderV3Context';
import { ProviderDetailsForm } from '../../views/manage-provider-v3/provider-details-form';

type AddPractitionerModalProps = {
  modalProps: ModalControlModalProps;
};

const modalWidth = SCHEDULE_AVAILABILITY_HOURS_MAX_WIDTH;

export const AddPractitionerModal = ({ modalProps }: AddPractitionerModalProps) => {
  const { t } = useTranslation('schedule');

  const { onClose, locationId, providerDetails, setProviderDetails } = useAddProviderV3Context();

  useEffect(() => {
    if (!modalProps.show) {
      // reset state when modal get closed
      setProviderDetails({} as Provider);
    }
  }, [modalProps.show, setProviderDetails]);

  return (
    <Modal.Responsive {...modalProps} minWidth={modalWidth} maxWidth={modalWidth}>
      <Modal.Header title='test' onClose={onClose}>
        {t('Add Provider')}
      </Modal.Header>
      <Modal.Body css={{ maxHeight: 720, overflow: 'hidden' }}>
        <AnimatePresence initial={false} mode='popLayout'>
          <ProviderDetailsForm
            locationId={locationId}
            providerDetails={providerDetails}
            primaryButtonLabel={t('Save')}
            onClose={onClose}
          />
        </AnimatePresence>
      </Modal.Body>
    </Modal.Responsive>
  );
};
